

























import { Component, Prop, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';

interface SelectOption {
    label: string;
    value: number;
}

@Component({
    components: { vSelect },
})
export default class TagSelect extends Vue {
    @Prop({ required: true }) value!: number[];

    @Prop({ required: true }) options!: Record<string, any>[];

    @Prop({ default: 'name' }) labelField!: string;

    @Prop({ default: 'id' }) valueField!: string;

    @Prop({ default: 'Search...' }) placeholder!: string;

    addValue: SelectOption | null = null;

    get selectedItems(): Record<string, any>[] {
        return this.options.filter(o => this.value.includes(o[this.valueField]));
    }

    get availableOptions(): SelectOption[] {
        return this.options
            .filter(o => !this.value.includes(o[this.valueField]))
            .map(o => ({ label: o[this.labelField], value: o[this.valueField] }));
    }

    onAdd(option: SelectOption | null): void {
        if (!option) return;
        this.$emit('input', [...this.value, option.value]);
        this.$nextTick(() => {
            this.addValue = null;
        });
    }

    remove(id: number): void {
        this.$emit('input', this.value.filter(v => v !== id));
    }
}
